export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "engineLoad.worker.2edbd3d39acb0296afe4-23.worker.js");
}
